export const ROLES = {
  SUPER_ADMIN: "super_admin",
  BRANCH_ADMIN: "branch_admin",
  COUNSELOR: "counselor",
  RECEPTIONIST: "receptionist",
  FACULTY: "faculty",
  STUDENT: "student",
  PARENT: "parent",
  ACCOUNTANT: "accountant",
  HR: "hr",
  MARKETING: "marketing",
};

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  branch_admin: "Branch Admin",
  counselor: "Counselor",
  receptionist: "Receptionist",
  faculty: "Faculty",
  student: "Student",
  parent: "Parent",
  accountant: "Accountant",
  hr: "HR",
  marketing: "Marketing",
};

// Which roles see which nav item
export const NAV_ACCESS = {
  dashboard:    ["super_admin","branch_admin","counselor","receptionist","faculty","student","parent","accountant","hr","marketing"],
  my_portal:    ["student","parent"],
  leads:        ["super_admin","branch_admin","counselor","marketing","receptionist"],
  admissions:   ["super_admin","branch_admin","counselor","receptionist"],
  students:     ["super_admin","branch_admin","counselor","receptionist","faculty"],
  courses:      ["super_admin","branch_admin","faculty"],
  batches:      ["super_admin","branch_admin","faculty"],
  faculty:      ["super_admin","branch_admin","hr"],
  timetable:    ["super_admin","branch_admin","faculty","student","parent"],
  attendance:   ["super_admin","branch_admin","faculty","receptionist","student","parent"],
  fees:         ["super_admin","branch_admin","accountant","receptionist","student","parent"],
  tests:        ["super_admin","branch_admin","faculty","student"],
  assignments:  ["super_admin","branch_admin","faculty","student"],
  materials:    ["super_admin","branch_admin","faculty","student"],
  notifications:["super_admin","branch_admin","marketing","faculty","student","parent"],
  broadcast:    ["super_admin","branch_admin","marketing","accountant"],
  question_bank:["super_admin","branch_admin","faculty"],
  exam_admin:   ["super_admin","branch_admin","faculty"],
  exam_portal:  ["student"],
  hr:           ["super_admin","hr"],
  accounting:   ["super_admin","accountant"],
  branches:     ["super_admin"],
  users:        ["super_admin"],
};
